<div class="content-b">
  <div class="div-small-content" style="border-bottom: none !important; grid-template-columns: repeat(5, 1fr)!important;">
    <div class="btn-small-content-bairros">
      <div class="btn-small-content-2" (click)="openModal('IMOVEIS_CENTRO')">
        <img src="../../assets/bairros/home/bairro_centro.webp" alt="">
      </div>
      <p class="text-bairro">Centro</p>
    </div>
    <div class="btn-small-content-bairros">
      <div class="btn-small-content-2" (click)="openModal('IMOVEIS_CAMOBI')">
        <img src="../../assets/bairros/home/bairro_camobi.webp" alt="">
      </div>
      <p class="text-bairro">Camobi</p>
    </div>
    <div class="btn-small-content-bairros">
      <div class="btn-small-content-2" (click)="openModal('IMOVEIS_NS_MEDIANEIRA')">
        <img src="../../assets/bairros/home/bairro_medianeira.webp" alt="">
      </div>
      <p class="text-bairro">Nossa Senhora Medianeira</p>
    </div>
    <div class="btn-small-content-bairros">
      <div class="btn-small-content-2" (click)="openModal('IMOVEIS_NS_LOURDES')">
        <img src="../../assets/bairros/home/bairro_lourdes.webp" alt="">
      </div>
      <p class="text-bairro">Nossa Senhora de Lourdes</p>
    </div>
    <div class="btn-small-content-bairros">
      <div class="btn-small-content-2" (click)="openModal('IMOVEIS_NS_DORES')">
        <img src="../../assets/bairros/home/bairro_dores.webp" alt="">
      </div>
      <p class="text-bairro">Nossa Senhora das Dores</p>
    </div>
  </div>
</div>